<template>
  <div class="Comments">
    <SectionHeadline :text="mixWB('NOTE')" />

    <InputField
      name="comments"
      :value="comments"
      :placeholder="mixWB('NOTE_FOR_THE_REPORT')"
      :disableAutoSuggest="true"
      @blur="onFieldBlur" />
  </div>
</template>

<script>
import SectionHeadline from '@/components/FormElements/SectionHeadline'
import InputField from '@/components/FormElements/InputField'
import EventBus from '@/EventBus'

export default {
  name: 'Comments',
  data() {
    return {
      comments: '',
    }
  },
  methods: {
    onFieldBlur({ value }) {
      this.$emit('comments-update', value)
    },
    onTypeLoad({ comments }) {
      this.comments = comments
    },
  },
  components: {
    SectionHeadline,
    InputField,
  },
  created() {
    EventBus.$on('load-type-edit', this.onTypeLoad)
  },
  destroyed() {
    EventBus.$off('load-type-edit', this.onTypeLoad)
  },
}
</script>

<style lang="stylus" scoped>
  .Comments
    padding-top 10px
    padding-bottom 10px
</style>
